import React from 'react'
import "./Subtotal.css"
import CurrencyFormat from "react-currency-format";
import {useStateValue} from "./StateProvider";
import { StateProvider } from "./StateProvider";
import {getBasketTotal} from "./reducer";
function Subtotal() {

    const [{basket},dispatch] = useStateValue();
    return (
      
            <div className="subtotal">
              


                <CurrencyFormat
                  renderText={(value)=>(
                    <>

                    <p>
                        Subtotal ({basket.length} items):<strong>{` ${value} `}</strong>
                    </p>
                    </>
                )}
                decimaScale= {2}
                value = {getBasketTotal(basket)}
                displayType = {"text"}
                thousandSeprator={true}
                prefix ={"$"}


              />
                <button> Proceed to checkout</button>

            </div>
    )
}

export default Subtotal
